import {LAYOUT, MENU_BEHAVIOUR, MENU_PLACEMENT, NAV_COLOR, RADIUS, THEME_COLOR,} from 'constants.tsx';

export const IS_AUTH_GUARD_ACTIVE = true;
export const SERVICE_URL = 'https://center.nouraboelsoud.com/apis/v1/';
export const AdminRoot = '';
export const USE_MULTI_LANGUAGE = true;

// For detailed information: https://github.com/nfl/react-helmet#reference-guide
export const REACT_HELMET_PROPS = {
    defaultTitle: 'Nour Abo Elsoud',
    titleTemplate: '%s | Nour Abo Elsoud',
};

export const DEFAULT_PATHS = {
    APP: '/',
    LOGIN: AdminRoot + '/login',
    REGISTER: AdminRoot + '/register',
    FORGOT_PASSWORD: AdminRoot + '/forgot-password',
    RESET_PASSWORD: AdminRoot + '/reset-password',
    USER_WELCOME: AdminRoot + '/overview',
    NOTFOUND: AdminRoot + '/page-not-found',
    UNAUTHORIZED: AdminRoot + '/unauthorized',
    INVALID_ACCESS: AdminRoot + '/invalid-access',
};

export const DEFAULT_SETTINGS = {
    MENU_PLACEMENT: MENU_PLACEMENT.Vertical,
    MENU_BEHAVIOUR: MENU_BEHAVIOUR.Unpinned,
    LAYOUT: LAYOUT.Fluid,
    RADIUS: RADIUS.Standard,
    COLOR: THEME_COLOR.DarkGreen,
    NAV_COLOR: NAV_COLOR.Dark,
    USE_SIDEBAR: false,
};


export const REDUX_PERSIST_KEY = 'starter-project';
